<template>
  <section class="dp-layout dismissal-admin-page">
    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick" />
    </section>
    <section class="dp-right">
      <div class="dismissal-admin-head">
        <div class="dismissal-admin-scope">{{ selectedClassName || '请选择左侧组织节点' }}</div>
        <div class="dismissal-admin-actions">
          <el-radio-group v-model="viewMode" size="small" @change="changeViewMode">
            <el-radio-button label="admin">已设置管理员</el-radio-button>
            <el-radio-button label="all">查看全部学生</el-radio-button>
          </el-radio-group>
          <el-input
            v-model="keyword"
            class="student-search"
            size="small"
            clearable
            prefix-icon="el-icon-search"
            placeholder="搜索姓名、学号或卡号"
            @clear="searchStudents"
          />
          <el-button size="small" type="primary" icon="el-icon-search" :loading="loading" @click="searchStudents">
            搜索
          </el-button>
          <el-button size="small" icon="el-icon-download" :loading="exporting" :disabled="!departmentId" @click="exportList">
            导出放学管理员报表
          </el-button>
        </div>
      </div>

      <div class="dismissal-admin-note">
        <i class="el-icon-info"></i>
        <span><b>操作说明：</b>点击学生行末的操作按钮即可立即生效。</span>
      </div>

      <div class="dismissal-admin-summary">
        <span>共 <b>{{ total }}</b> 名学生</span>
        <span v-if="departmentId">班级 <b>{{ classCount }}</b> 个</span>
        <span v-if="departmentId" class="dismissal-admin-unset">
          未设置管理员班级 <b>{{ unsetClassCount }}</b> 个
          <el-button type="text" size="small" @click="openUnset">查看详情</el-button>
        </span>
        <span class="dismissal-admin-summary-tip">{{ isClassSelected ? '管理员可发起本班放学' : '汇总查看模式，请进入班级进行设置' }}</span>
      </div>

      <div class="tbl-scroll-host dismissal-admin-table-host">
        <el-table
          ref="studentTable"
          v-loading="loading"
          :data="visibleStudents"
          height="100%"
          border
          stripe
          class="dismissal-admin-table"
        >
        <el-table-column prop="SeatNumber" label="号次" width="80" align="center" />
        <el-table-column prop="ClassName" label="班级" width="130" show-overflow-tooltip />
        <el-table-column prop="StuCode" label="学号" width="130" show-overflow-tooltip />
        <el-table-column prop="StudentName" label="学生姓名" min-width="110" />
        <el-table-column prop="CardNumber" label="卡号" width="130" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.CardNumber || '—' }}</template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.IsDismissalPersonnel ? 'success' : 'info'" size="mini">
              {{ scope.row.IsDismissalPersonnel ? '放学管理员' : '普通学生' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="CreateUserName" label="设置人" min-width="140" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.CreateUserName || '—' }}</template>
        </el-table-column>
        <el-table-column prop="CreateTime" label="设置时间" width="170" align="center">
          <template slot-scope="scope">{{ formatTime(scope.row.CreateTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="130" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="!scope.row.IsDismissalPersonnel"
              type="text"
              size="small"
              :disabled="saving"
              @click="toggleStudentRole(scope.row, true)"
            >
              设为管理员
            </el-button>
            <el-button
              v-else
              type="text"
              size="small"
              class="danger-text"
              :disabled="saving"
              @click="toggleStudentRole(scope.row, false)"
            >
              取消管理员
            </el-button>
          </template>
        </el-table-column>
        </el-table>
      </div>
      <div class="dismissal-admin-pagination">
        <el-pagination
          layout="total, prev, pager, next, jumper"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          @current-change="changePage"
        />
      </div>
      <el-dialog title="未设置放学管理员的班级" custom-class="dismissal-unset-dialog" :visible.sync="unsetVisible" width="720px" top="8vh" :close-on-click-modal="false" @opened="layoutUnsetTable">
        <div class="unset-panel">
        <div class="unset-toolbar">
          <span class="unset-scope">
            <template v-if="isClassSelected">{{ selectedClassName || '当前范围' }}{{ unsetClassCount ? '未设置放学管理员' : '已设置放学管理员' }}</template>
            <template v-else-if="unsetClassCount">{{ selectedClassName || '当前范围' }}，共 {{ classCount }} 个班级，未设置 <b class="unset-count">{{ unsetClassCount }}</b> 个</template>
            <template v-else>{{ selectedClassName || '当前范围' }}，共 {{ classCount }} 个班级，均已设置放学管理员</template>
          </span>
          <el-input v-model="unsetKeyword" size="small" clearable placeholder="搜索年级或班级" @input="unsetPage = 1" />
          <el-button size="small" icon="el-icon-download" :loading="unsetExporting" :disabled="!departmentId" @click="exportUnset">导出</el-button>
        </div>
        <div ref="unsetTableWrap" class="unset-table-wrap">
          <el-table v-if="filteredUnsetClasses.length" :data="pagedUnsetClasses" :height="unsetTableHeight" border size="small">
            <el-table-column prop="GradeName" label="年级" min-width="160" show-overflow-tooltip />
            <el-table-column prop="ClassName" label="班级" min-width="140" show-overflow-tooltip />
            <el-table-column prop="StudentCount" label="班级人数" width="100" align="center" />
          </el-table>
          <div v-else class="unset-empty">{{ unsetEmptyText }}</div>
        </div>
        <div v-if="filteredUnsetClasses.length" class="unset-pagination">
          <el-pagination
            small
            layout="total, prev, pager, next"
            :current-page="unsetPage"
            :page-size="unsetPageSize"
            :total="filteredUnsetClasses.length"
            @current-change="page => unsetPage = page"
          />
        </div>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import DepartmentPane from '@/components/DepartmentPane'
import { getDismissalPersonnelAdmin, setDismissalPersonnelAdmin, exportDismissalPersonnelAdmin } from '@/api/dismissal'
import { toDeptId, treeNodeDeptId } from '@/utils/deptCascaderProps'

export default {
  name: 'DismissalPersonnelManage',
  components: { DepartmentPane },
  data() {
    return {
      classId: 0,
      departmentId: 0,
      selectedNodeType: '',
      selectedClassName: '',
      viewMode: 'admin',
      keyword: '',
      loading: false,
      saving: false,
      exporting: false,
      unsetExporting: false,
      unsetVisible: false,
      unsetKeyword: '',
      unsetPage: 1,
      unsetPageSize: 10,
      unsetTableHeight: 400,
      classCount: 0,
      unsetClassCount: 0,
      unsetClasses: [],
      students: [],
      page: 1,
      pageSize: 20,
      total: 0
    }
  },
  computed: {
    isClassSelected() {
      return this.selectedNodeType === 'class'
    },
    visibleStudents() {
      return this.students
    },
    filteredUnsetClasses() {
      const keyword = (this.unsetKeyword || '').trim()
      if (!keyword) return this.unsetClasses
      return this.unsetClasses.filter(item => `${item.GradeName || ''}${item.ClassName || ''}`.includes(keyword))
    },
    pagedUnsetClasses() {
      const start = (this.unsetPage - 1) * this.unsetPageSize
      return this.filteredUnsetClasses.slice(start, start + this.unsetPageSize)
    },
    unsetEmptyText() {
      if (this.unsetClassCount) return '没有匹配的班级'
      return this.isClassSelected ? '该班级已设置放学管理员' : '当前范围的班级均已设置放学管理员'
    }
  },
  watch: {
    'filteredUnsetClasses.length'() {
      if (this.unsetVisible) this.layoutUnsetTable()
    }
  },
  methods: {
    treeNodeClick(data) {
      const type = String((data && (data.DeptOrgType || data.deptOrgType)) || '').toLowerCase()
      const nodeId = treeNodeDeptId(data)
      this.departmentId = nodeId || ''
      this.selectedNodeType = type
      this.classId = type === 'class' ? nodeId : ''
      this.selectedClassName = nodeId ? (data.label || data.name || '') : ''
      this.students = []
      this.unsetClasses = []
      this.classCount = 0
      this.unsetClassCount = 0
      this.keyword = ''
      this.page = 1
      if (this.departmentId) this.loadStudents()
    },
    searchStudents() {
      this.page = 1
      this.loadStudents()
    },
    changeViewMode() {
      this.page = 1
      this.loadStudents()
    },
    async exportList() {
      if (!this.departmentId) return
      this.exporting = true
      try {
        const res = await exportDismissalPersonnelAdmin({ departmentId: this.departmentId })
        const blob = res.data
        if (!blob || !blob.size) {
          this.$message.error('没有可导出的数据')
          return
        }
        const url = window.URL.createObjectURL(new Blob([blob]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `放学管理员统计_${this.selectedClassName || '组织节点'}.xlsx`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } catch (e) {
        this.$message.error('导出失败')
      } finally {
        this.exporting = false
      }
    },
    openUnset() {
      this.unsetKeyword = ''
      this.unsetPage = 1
      this.unsetVisible = true
    },
    layoutUnsetTable() {
      this.$nextTick(() => {
        const wrap = this.$refs.unsetTableWrap
        if (!wrap || wrap.clientHeight < 80) return
        this.unsetTableHeight = wrap.clientHeight
      })
    },
    async exportUnset() {
      if (!this.departmentId) return
      this.unsetExporting = true
      try {
        const res = await exportDismissalPersonnelAdmin({ departmentId: this.departmentId, onlyUnset: true })
        const blob = res.data
        if (!blob || !blob.size) {
          this.$message.error('没有可导出的数据')
          return
        }
        const url = window.URL.createObjectURL(new Blob([blob]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `未设置放学管理员班级_${this.selectedClassName || '组织节点'}.xlsx`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } catch (e) {
        if (!e || !e.bizMessage) this.$message.error('导出失败')
      } finally {
        this.unsetExporting = false
      }
    },
    changePage(page) {
      this.page = page
      this.loadStudents()
    },
    async loadStudents() {
      if (!this.departmentId) return
      this.loading = true
      try {
        const res = await getDismissalPersonnelAdmin({
          departmentId: this.departmentId,
          page: this.page,
          intPageSize: this.pageSize,
          onlyAdmin: this.viewMode === 'admin',
          keyword: this.keyword
        })
        const response = res.data && res.data.success ? res.data.response : null
        this.students = response && response.data
          ? response.data.map(item => Object.assign(item, {
            StudentName: item.StudentName || item.studentName || '',
            StuCode: item.StuCode || item.stuCode || '',
            CardNumber: item.CardNumber || item.cardNumber || '',
            ClassName: item.ClassName || item.className || '',
            StudentId: item.StudentId || item.studentId,
            ClassId: item.ClassId || item.classId,
            SeatNumber: item.SeatNumber !== undefined ? item.SeatNumber : item.seatNumber,
            CreateTime: item.CreateTime || item.createTime,
            CreateUserName: item.CreateUserName || item.createUserName || '',
            IsDismissalPersonnel: item.IsDismissalPersonnel !== undefined
              ? item.IsDismissalPersonnel
              : !!item.isDismissalPersonnel
          }))
          : []
        this.total = response ? (response.dataCount || 0) : 0
        this.classCount = response ? (response.ClassCount || 0) : 0
        this.unsetClassCount = response ? (response.UnsetClassCount || 0) : 0
        this.unsetClasses = response && response.UnsetClasses ? response.UnsetClasses : []
        if (response && this.page > 1 && this.students.length === 0) {
          const lastPage = Math.max(1, Math.ceil(this.total / this.pageSize))
          if (this.page > lastPage) {
            this.page = lastPage
            await this.loadStudents()
          }
        }
      } finally {
        this.loading = false
      }
    },
    toggleStudentRole(row, isAdmin) {
      const action = isAdmin ? '设为放学管理员' : '取消放学管理员'
      this.$confirm(`确定要将“${row.StudentName}”${action}吗？`, '确认操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updateStudentRole(row, isAdmin)
      }).catch(() => {})
    },
    async updateStudentRole(row, isAdmin) {
      const oldValue = row.IsDismissalPersonnel
      this.$set(row, 'IsDismissalPersonnel', isAdmin)
      this.saving = true
      try {
        const res = await setDismissalPersonnelAdmin({
          classId: row.ClassId,
          studentId: row.StudentId,
          isAdmin
        })
        if (!res.data || !res.data.success) {
          throw new Error((res.data && res.data.msg) || '保存失败')
        }
        this.$message.success(isAdmin ? '已设为放学管理员' : '已取消放学管理员')
        await this.loadStudents()
      } catch (e) {
        this.$set(row, 'IsDismissalPersonnel', oldValue)
        this.$message.error(e.message || '保存失败')
      } finally {
        this.saving = false
      }
    },
    formatTime(value) {
      return value ? String(value).replace('T', ' ').slice(0, 19) : '—'
    }
  }
}
</script>

<style scoped>
.dismissal-admin-page { background:#f3f6fa; padding:16px; box-sizing:border-box; }
.dismissal-admin-head { display:flex; justify-content:space-between; align-items:center; gap:12px; padding:12px 16px; background:#fff; border:1px solid #e8edf3; border-radius:8px; box-shadow:0 3px 12px rgba(42,67,101,.04); container-type:inline-size; container-name:dismissal-admin-head; }
.dismissal-admin-scope { flex:1; min-width:0; color:#405d7c; font-size:14px; font-weight:600; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.dismissal-admin-actions { display:flex; align-items:center; gap:10px; flex-shrink:0; }
.student-search { width:210px; }
.dismissal-admin-note { margin:12px 0; padding:11px 14px; color:#667992; background:#f8fbff; border:1px solid #e0ebf8; border-radius:7px; font-size:12px; }
.dismissal-admin-note i { margin-right:7px; color:#4a8bca; }
.dismissal-admin-note b { color:#405d7c; font-weight:600; }
.dismissal-admin-summary { display:flex; align-items:center; gap:16px; min-height:34px; padding:0 4px; color:#536780; font-size:13px; }
.dismissal-admin-summary b { color:#3478bf; font-size:16px; }
.dismissal-admin-unset b { color:#d48806; }
.dismissal-admin-unset .el-button { margin-left:4px; padding:0; }
.dismissal-admin-summary-tip { margin-left:auto; color:#9aa7b8; font-size:12px; }
.dismissal-admin-pagination { padding:10px 0 0; text-align:right; }
.danger-text { color:#d05b5b; }
.unset-panel { height:460px; display:flex; flex-direction:column; }
.unset-toolbar { flex-shrink:0; display:flex; align-items:center; gap:8px; margin-bottom:12px; color:#536780; font-size:13px; }
.unset-scope { min-width:0; }
.unset-scope b { color:#d48806; font-size:16px; font-weight:600; }
.unset-toolbar .el-input { width:220px; margin-left:auto; }
.unset-table-wrap { flex:1; min-height:0; overflow:hidden; }
.unset-empty { height:100%; display:flex; align-items:center; justify-content:center; margin:0; color:#909399; font-size:13px; text-align:center; }
.unset-pagination { flex-shrink:0; display:flex; justify-content:flex-end; padding:12px 0 0; }

@media screen and (max-width: 1600px) {
  .dismissal-admin-head { align-items:flex-start; flex-wrap:wrap; }
  .dismissal-admin-head > div:first-child { flex:1 1 100%; min-width:0; }
  .dismissal-admin-actions { width:100%; flex-wrap:wrap; justify-content:flex-end; }
  .student-search { width:190px; }
}

@media screen and (max-width: 768px) {
  .dismissal-admin-page { padding:10px; }
  .dismissal-admin-head { display:block; padding:12px; }
  .dismissal-admin-scope { margin-bottom:10px; }
  .dismissal-admin-actions { justify-content:flex-start; gap:8px; flex-wrap:wrap; }
  .student-search { width:100%; order:3; }
  .dismissal-admin-note { line-height:1.6; }
  .dismissal-admin-summary { align-items:flex-start; flex-direction:column; gap:2px; padding:3px 0 7px; }
  .dismissal-admin-pagination { overflow:auto; white-space:nowrap; }
}

@container dismissal-admin-head (max-width: 800px) {
  .dismissal-admin-head { align-items:flex-start; flex-wrap:wrap; }
  .dismissal-admin-head > div:first-child { flex:1 1 100%; min-width:0; }
  .dismissal-admin-actions { width:100%; flex-wrap:wrap; justify-content:flex-start; }
  .student-search { width:190px; }
}
</style>

<style>
.el-dialog.dismissal-unset-dialog {
  height: 560px;
  max-height: calc(100vh - 16vh - 24px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.el-dialog.dismissal-unset-dialog .el-dialog__header { flex-shrink: 0; }
.el-dialog.dismissal-unset-dialog .el-dialog__body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 12px 20px 16px;
}
.el-dialog.dismissal-unset-dialog .unset-count {
  color: #d48806;
  font-size: 16px;
  font-weight: 600;
}
</style>
